export default class OfficeExpense {
    id: number;
    amount?: number;
    clientNumber?: number;
    clientName?: string;
    receipts?: number;
    projectNumber?: number;
    projectId?: number;
    payPeriod?: number;
    projectName?: string;
    sectionNumber?: number;
    sectionName?: string;
    unitId?: number;
    unitName?: string;
    unitNumber?: number;
    accountNumber: number;
    discount?: string;
    entrySource?: string;
    phone?: string;
    postage?: string;
    shipping?: string;
    copies?: string;
    abstractFees?: string;
    oneThousandTwoAs?: string;
    fax?: string;
    officeCopies?: string;
    recordingFees?: string;
    bankCharges?: string;
    draft?: string;
    maps?: string;
    notary?: string;
    formsAndSupplies?: string;
    other?: string;
    otherDescription?: string;
    billingOffice?: string;
    endDate?: Date;
    beginDate?: Date;
    expenseType?: string;
    imageBase64?: string;
    officeExpenses?: Array<OfficeExpense>;
    createdBy?: string;
    createdDate?: Date;
    code?: string;
    unitIds?: Record<string, number>;
}



// WEBPACK FOOTER //
// ./src/models/AP/OfficeExpense.ts